const state = {
  website: 'https://www.tinytreasuresnyc.com/',
  platformURL: 'https://ttna.enginehire.io/',
  platformLoginURL: 'https://ttna.enginehire.io/login',
  agencyHumanName: 'Tiny Treasures',
  agencyShortName: 'TTNA',
};

const mutations = {

};

const actions = {

};

const getters = {
  website (state) {
    return state.website
  },
  platformURL (state) {
    return state.platformURL
  },
  platformLoginURL (state) {
    return state.platformLoginURL
  },
  agencyHumanName (state) {
    return state.agencyHumanName
  },
  agencyShortName (state) {
    return state.agencyShortName
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/agency.js